









































import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref, InjectReactive } from 'vue-property-decorator';

// Shared types
import { RequestOfferRequest, RequestClient } from '@coldtec/cos-types';

// Modal
import Modal from '@/components/modal/Modal.vue';

// Used for the possible actions of the footer
import { ButtonOptions, ButtonType } from '@/components/input/types';

/**
 *  Modal that is shown when a user updated a request (internal mode).
 */
@Component
export default class PersonalDetailsSavedModal extends Vue {

    @Ref('modal')
    private modal!: Modal;

    @InjectReactive('request')
    private request!: RequestOfferRequest;

    /**
     *  Holding the download URL of the updated offer PDF.
     */
    private downloadUrl = '';

    /**
     *  Holding the data of the possible options.
     */
    private actions: { [key: string]: ButtonOptions; } = {
        cancel: {
            type: ButtonType.Transparent,
            title: 'Sluit dit venster',
            content: 'Sluiten',
        },
        download: {
            title: 'Download de offerte',
            content: 'Download de offerte',
        },
    };

    /**
     *  Used to get the info to render in the modal,
     *  interpolated with the name of the client.
     */
    private get info(): string {

        const client: RequestClient = this.request.client;

        return `De offerte voor ${ client.salutation } ${ client.first_name } ${ client.last_name } is succesvol aangepast.`;

    }

    /**
     *
     *  Used to open the modal.
     *
     *  @param url The download URL of the updated offer PDF.
     *
     */
    public open(url: string): void {

        this.downloadUrl = url;

        this.modal.open();

    }

    /**
     *  Used to close the modal.
     */
    public close(): void {

        this.modal.close();

    }

    /**
     *  Used to download the offer PDF.
     */
    private download(): void {

        window.open(this.downloadUrl);

    }

}
